module.exports = __webpack_public_path__ + "img/foto-academia-6.782c7c14.png";